<!-- <div class="empty-space"></div> -->
<div class="jobs" [dir]="'Direction' | translate">
    <div class="container"  data-aos="fade-up" data-aos-duration="1000">
        <div class="container" [dir]="'Direction' | translate">
            <span class="section-title">{{ "AboutUS.Title" | translate }}</span>
          </div>
        <div class="jobs-inner about-details">
            <div class="row mx-2">
                <div class="col-md-6">
                    <h1>{{ "WhoWeAre.Title" | translate }}</h1>
                    <p>{{ "WhoWeAre.Content" | translate }}</p>
                </div>
                <div class="col-md-6">
                    <img [src]="'WhoWeAre.Image' | translate" class="img-fluid" alt="{{ 'WhoWeAre.Title' | translate }}">
                </div>
            </div>
            <div class="row mt-4 mx-2">
                <div class="col-md-6">
                    <img [src]="'Mission.Image' | translate" class="img-fluid" alt="{{ 'Mission.Title' | translate }}">
                </div>
                <div class="col-md-6">
                    <h1>{{ "Mission.Title" | translate }}</h1>
                    <p>{{ "Mission.Content" | translate }}</p>
                </div>
            </div>
            <div class="row mt-4 mx-2">
                <div class="col-md-6">
                    <h1>{{ "Vision.Title" | translate }}</h1>
                    <p>{{ "Vision.Content" | translate }}</p>
                </div>
                <div class="col-md-6">
                    <img [src]="'Vision.Image' | translate" class="img-fluid" alt="{{ 'Vision.Title' | translate }}">
                </div>
            </div>
        </div>
        <div class="introduction-section">
       
            <div class="video-wrapper">
              <iframe
                *ngIf="introductionVideo"
                width="100%"
                height="315"
                [src]="introductionVideo"
                frameborder="0"
                allowfullscreen>
              </iframe>
            </div>
          </div>
    </div>
    
</div>

<app-proyects></app-proyects>